import type { ButtonEmphasis } from '~/utils/button'

export function useButtonEmphasis() {
  const { theme } = useTheme()

  const colorMode = useColorMode()

  const emphasis = computed<ButtonEmphasis | undefined>(() => {
    return theme.value === 'blurple' && colorMode.value === 'light' ? 'inverted' : undefined
  })

  return {
    emphasis,
  }
}
